import { render } from "./ExpenseReceiptsTable.vue?vue&type=template&id=05c88a8c&scoped=true"
import script from "./ExpenseReceiptsTable.vue?vue&type=script&lang=js"
export * from "./ExpenseReceiptsTable.vue?vue&type=script&lang=js"

import "./ExpenseReceiptsTable.vue?vue&type=style&index=0&id=05c88a8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c88a8c"]])

export default __exports__